// extracted by mini-css-extract-plugin
module.exports = {"component":"Footer_component__5P1vX","copyright":"Footer_copyright__tIke_"};